import React from 'react';
import { Select, Spin } from 'antd';
import { useQuery } from '@apollo/client';
import { QUERY_INTERNAL_USERS } from '../../queries/UserQueries';
import AdminRoles from '../../constants/AdminRoles';

const { Option } = Select;

interface InternalUserSelectProps {
  value?: string | number | null;
  onChange?: (value: string | number) => void;
  placeholder?: string;
  disabled?: boolean;
  style?: React.CSSProperties;
}

const InternalUserSelect: React.FC<InternalUserSelectProps> = ({
  value,
  onChange,
  placeholder = 'Select internal user',
  disabled = false,
  style,
  ...props
}) => {
  const { data, loading, error } = useQuery(QUERY_INTERNAL_USERS, {
    variables: {
      where: {
        role_id: {
          in: [
            AdminRoles.InternalMember,
            AdminRoles.InternalManager,
            AdminRoles.InternalAdministrator,
            AdminRoles.SuperAdmin,
          ],
        },
      },
      order: [{ field: 'first_name', order: 'ASC' }],
    },
  });

  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      disabled={disabled}
      style={style}
      notFoundContent={loading ? <Spin size="small" /> : null}
      {...props}
    >
      {data && !error && !loading
        ? data.listUser.list.map((user: any) => (
            <Option key={user.user_id} value={user.user_id}>
              {user.full_name} ({user.adminRole?.name || 'No Role'})
            </Option>
          ))
        : null}
    </Select>
  );
};

export default InternalUserSelect;
